import { toast } from 'react-toastify';

const CustomToast = (text, type) =>
  toast(<div dangerouslySetInnerHTML={{ __html: text }} />, {
    theme: 'light',
    type: type,
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true
  });

export default CustomToast;
